import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../store/action/auth';
import axios from "axios";
import {API} from "../../config";
import moment from 'moment';
import AdminPurchaseOrderItemsTable from "../../components/tables/AdminPurchaseOrderItemsTable";
import ProductForm from "../../components/forms/ProductForm";
import Modal from "../../components/molecules/Modal";
import {updateCategories} from "../../store/action/catalog";
import {isContainNumber, isContainText} from "../../services/helpers/validator";
import {createProductByAdmin, updateProductImage} from "../../store/action/product";

const PurchaseOrderDetail = (props) => {
    const { token } = isAuthenticated();
    const [ loading, setLoading ] = useState(true);
    const [ items, setItems ] = useState([]);
    const [ categories, setCategories ] = useState([]);
    const [ show, setShow ] = useState({
        modal: false,
        modalType: ''
    });
    const [ item, setItem ] = useState({
        id:"",
        name:"",
        sku:"",
        details: "",
        quantity:""
    });
    const [ values, setValues] = useState(({
        error:false,
        info:'',
        pageLoading:true,
        productSubmitLoading:false,
        progress:0,
        success:false
    }));
    const [ purchaseOrder, setPurchaseOrder ] = useState({
        id: "",
        warehouseName: "",
        warehouseAddress: "",
        deliveryDate: "",
        status: "",
        items: [],
        note: "",
        userId: "",
        userName: "",
        userOrganization: "",
        supplierId: "",
        supplierName: "",
        supplierContactName: "",
        supplierContactPhone: "",
        catalogId: "",
        catalogName: "",
        catalogProducts: []
    });
    let catalogInitial = {
        category:'',
        categories:[],
        description: '',
        link: '-',
        products: [],
        productId:'',
        productName: '',
        productPrice: '',
        productDetails: '',
        productImage: '',
        productLength:0,
        productHeight:0,
        productWidth:0,
        productWeight:0,
        productCategory:'',
        productSku:'',
        productStock:0,
        productStatus: 'active',
    };
    const [ catalog, setCatalog ] = useState(catalogInitial);
    const [ newCatalog, setNewCatalog ] = useState(catalogInitial);


    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const res = await axios.get(`${API}/v1/purchase_orders/${props.match.params.purchaseOrderId}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        Authorization: `Bearer ${token}`
                    },
                });
            if (res.data.success) {
                let {data} = res;
                 setPurchaseOrder({
                     id: data.id,
                     warehouseName: data.warehouse_name,
                     warehouseAddress: data.warehouse_address,
                     deliveryDate: data.delivery_date,
                     status: data.status,
                     items: data.items,
                     note: data.note,
                     userId: data.user_id,
                     userName: data.user_name,
                     userOrganization: data.user_organization,
                     supplierId: data.supplier_id,
                     supplierName: data.supplier_name,
                     supplierContactName: data.supplier_contact_name,
                     supplierContactPhone: data.supplier_contact_phone,
                     catalogId: data.catalog_id,
                     catalogName: data.catalog_name,
                     catalogProducts: data.catalog_products
                });
                setCategories(data.catalog_product_categories);
                setCatalog({...catalog, categories: data.catalog_product_categories});
                setNewCatalog({
                    ...newCatalog,
                    categories: data.catalog_product_categories,
                    productCategory: data.catalog_product_categories[0]
                });
                if (data.catalog_products.length > 0) {
                    setItem({
                        id:data.catalog_products[0].id,
                        name:data.catalog_products[0].name,
                        sku:data.catalog_products[0].sku,
                        details:data.catalog_products[0].details,
                        quantity:data.catalog_products[0].quantity
                    })
                }
            } else {
                alert(res.error)
            }
        } catch (e) {
            console.log (e);
            alert(e.error)
        }
        setLoading(false)
    };

    const onSubmitItems = async () => {
        try {
            const res = await axios.post(`${API}/v1/purchase_orders/${purchaseOrder.id}`, {
                    items: items
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        Authorization: `Bearer ${token}`
                    },
                });
            if (res.data.success) {
                let {data} = res;
                setPurchaseOrder({
                    ...purchaseOrder,
                    items: data.items,
                    status: data.status
                });
                alert("Berhasil di update")
            } else {
                alert(res.error)
            }
        } catch (e) {
            console.log (e);
            alert(e.error)
        }
        setLoading(false)
    };

    const onSendPurchaseOrderEmail = async () => {
        try {
            const res = await axios.post(`${API}/v1/purchase_orders/${purchaseOrder.id}/email`, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                },
            });
            if (res.data.success) {
                alert("Berhasil Kirim Purchase Order")
            } else {
                alert(res.error)
            }
        } catch (e) {
            console.log (e);
            alert(e.error)
        }
    };

    const onSendPurchaseOrderConfirmStock = async () => {
        try {
            const res = await axios.post(`${API}/v1/purchase_orders/${purchaseOrder.id}/confirm`, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                },
            });
            if (res.data.success) {
                alert("Berhasil Konfirmasi Purchase Order ke Stok Barang")
                window.location.reload()
            } else {
                alert(res.data.error)
            }
        } catch (e) {
            console.log (e);
            alert(e.response.data.error)
        }
    };

    const onItemChange = name => e => {
        const value = e.target.value;
        setItem({
            ...item,
            [name]: value
        });
    };

    const onItemSelect = (i) => {
        let parsedItem = JSON.parse(i.target.value);
        setItem({
            ...item,
            id:parsedItem.id,
            name:parsedItem.name,
            sku: parsedItem.sku,
            details: parsedItem.details
        })
    };

    const onAddItem = () => {
        if (!item.id || !item.quantity) {
            alert("Data barang kurang lengkap");
            return
        }
        let copyItem = items;
        let check = copyItem.filter(i => i.id === item.id);
        if (check.length !== 0) {
            alert("Barang sudah dimasukkan");
            return
        }
        copyItem.push(item);
        setItems(copyItem);
        setItem({
            id:purchaseOrder.catalogProducts[0].id,
            name:purchaseOrder.catalogProducts[0].name,
            sku:purchaseOrder.catalogProducts[0].sku,
            details:purchaseOrder.catalogProducts[0].details,
            quantity:""
        })
    };

    const onRemoveItem = (id) => {
        let copyItems = items;
        let filteredItems = copyItems.filter(i => i.id !== id);
        setItems(filteredItems);
    };

    const handleModalShow = (type) => {
        setShow({
            modal:true,
            modalType: type
        });
    };

    const handleModalClose = () => {
        setShow({
            ...modal,
            modal:false
        });
        setNewCatalog({
            ...newCatalog,
            productName: '',
            productPrice: '',
            productDetails: '',
            productSku: '',
            productImage: '',
            productLength:0,
            productHeight:0,
            productWidth:0,
            productWeight:0,
            productCategory:'',
        })
    };

    const onSubmitNewCategories = async () => {
        const resCat = await updateCategories(token, purchaseOrder.catalogId, {categories: newCatalog.categories});
        if (resCat.success){
            alert("Kategori berhasil disimpan");
            window.location.reload()
        } else {
            alert("Gagal update kategori")
        }
    };

    const onAddCategory = async () => {
        if (!newCatalog.category) {
            alert("Kategori masih kosong");
            return
        }
        let copyCategory = newCatalog.category;
        let copyCategories = newCatalog.categories;
        copyCategories.push(copyCategory);

        setCatalog({
            ...catalog,
            categories: []
        });

        setNewCatalog({
            ...newCatalog,
            category: '',
            categories: copyCategories,
            productCategory: newCatalog.category
        })
    };

    const onRemoveCategory = async (category) => {
        let copyCategories = newCatalog.categories;
        let filteredCategories = copyCategories.filter(i => i !== category);
        setNewCatalog({
            ...newCatalog,
            category: '',
            categories: filteredCategories
        })
    };

    const handleCategoryChange = name => e => {
        const value = e.target.value;
        setNewCatalog({ ...newCatalog, [name]: value });
    };

    const onSubmitProduct = async (type) => {
        let resProd;
        const checkName = await isContainText('Nama barang',newCatalog.productName);
        if (!checkName .success) return setValues({...values, error: checkName.message});
        const checkPrice = await isContainText('Harga barang',newCatalog.productPrice);
        if (!checkPrice .success) return setValues({...values, error: checkPrice.message});
        const checkStock = await isContainNumber('Stok barang',newCatalog.productStock);
        if (!checkStock .success) return setValues({...values, error: checkStock.message});
        if (!newCatalog.productLength || !newCatalog.productWidth || !newCatalog.productHeight || !newCatalog.productWeight) {
            return setValues({...values, error: 'Dimensi atau berat barang masih kosong. Mohon diisi.'})
        }

        setValues({
            ...values,
            info:'Membuat produk baru...',
            productSubmitLoading: true
        });

        try {

            resProd = await createProductByAdmin(token, purchaseOrder.userId, newCatalog);

            if (resProd.success) {
                alert("Produk berhasil dibuat.");
                window.location.reload()
            } else {
                setValues({
                    ...values,
                    info:'',
                    error: resProd.error,
                    productSubmitLoading: false
                });
                alert("Produk gagal dibuat.");
            }
        } catch (e) {
            console.log (e);
            setValues({
                ...values,
                info:'',
                error: resProd.error,
                productSubmitLoading: false
            });
            alert("Produk gagal dibuat.");
        }
    };

    const showError = () => (
        <div
            className="alert alert-danger mb-0"
            style={{display: values.error ? '' : 'none'}}
        >
            { values.error }
        </div>
    );

    const showInfo = () => (
        <div
            className="alert alert-info mb-0"
            style={{display: values.info ? '' : 'none'}}
        >
            { values.info }
        </div>
    );

    const handleProductChange = name => e => {
        const value = e.target.value;
        setNewCatalog({ ...newCatalog, [name]: value });
        setValues({...values, error: ''})
    };

    const onSelectImageProduct = async (e) => {
        const data = e.target.files[0];
        const res = await updateProductImage(token, data);
        if(res.success) {
            alert("Foto produk telah diupdate");
            setNewCatalog({
                ...newCatalog,
                productImage: res.image
            })
        } else {
            alert("Foto produk gagal diupadte. Coba ulangi lagi yuk!")
        }
    };

    const modal = () => {
        let body, title, bText, bClick, size, type, lbClick, rbClick;
        if (show.modalType === 'editCategory') {
            lbClick = () => handleModalShow('addProduct');
            rbClick = () => onSubmitNewCategories();
            type = 'yesno';
            title = `Edit Kategori`;
            body = (
                <div className="p-4">
                    <h6>Kategori Katalog {purchaseOrder.catalogName}</h6>
                    <div>
                        {
                            newCatalog.categories.map((i,idx) => (
                                <div key={idx} className="pl-4 py-1 d-flex justify-content-between bg-lighter mb-1">
                                    <b className="pt-1">{i}</b>
                                    <a onClick={() => onRemoveCategory(i)}
                                       className="action-item mr-2"
                                       data-toggle="tooltip"
                                       title="Remove">
                                        <i className="fas fa-times"></i>
                                    </a>
                                </div>
                            ))
                        }
                    </div>
                    <div className="input-group mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Nama Kategori"
                            onChange={handleCategoryChange('category')}
                            value={newCatalog.category}
                        />
                        <div className="input-group-append">
                            <button
                                onClick={onAddCategory}
                                className="btn btn-outline-primary"
                                type="button"
                            >
                                Tambah
                            </button>
                        </div>
                    </div>
                </div>
            )
        } else if (show.modalType === 'addProduct') {
            lbClick = () => handleModalClose();
            type = 'yesno';
            size = 'md';
            if (catalog.categories.length === 0 ) {
                rbClick = () => onSubmitNewCategories();
                title = `Tambah Kategori`;
                body = (
                    <div className="p-4">
                        <h6>Kategori produk masih kosong. Tambah dulu ya!</h6>
                        <div>
                            {
                                newCatalog.categories.map((i,idx) => (
                                    <div key={idx} className="pl-4 py-1 d-flex justify-content-between bg-lighter mb-1">
                                        <b className="pt-1">{i}</b>
                                        <a onClick={() => onRemoveCategory(i)}
                                           className="action-item mr-2"
                                           data-toggle="tooltip"
                                           title="Remove">
                                            <i className="fas fa-times"></i>
                                        </a>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="input-group mb-3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nama Kategori"
                                onChange={handleCategoryChange('category')}
                                value={newCatalog.category}
                            />
                            <div className="input-group-append">
                                <button
                                    onClick={() => onAddCategory()}
                                    className="btn btn-outline-primary"
                                    type="button"
                                >
                                    Tambah
                                </button>
                            </div>
                        </div>
                    </div>
                )
            } else {
                rbClick = () => onSubmitProduct('new');
                lbClick = () => handleModalClose();
                type = 'yesno';
                size = 'lg';
                title = `Tambah Produk`;
                body = (
                    <ProductForm
                        className="p-4"
                        loading={values.productSubmitLoading}
                        handleChange={handleProductChange}
                        categories={categories}
                        onClickEditCategories={() => handleModalShow('editCategory')}
                        onProductImageSelect={onSelectImageProduct}
                        values={newCatalog}
                    />
                )
            }
        }

        return (
            <Modal
                bodyClassName="p-0"
                show={show.modal}
                size={size}
                onHide={handleModalClose}
                title={title}
                type={type}
                buttons
                footerStyle={{justifyContent:'flex-end'}}
                lbText="Kembali"
                lbClick={lbClick}
                rbText="Simpan"
                rbClick={rbClick}
            >
                { showError() }
                { showInfo() }
                { body }
            </Modal>
        )
    };


    if (loading) {
        return <p>Loading...</p>
    }

    return (
        <div className="bg-white rounded shadow p-4">
            { modal() }
            <div className="py-4">
                <div className=" d-flex justify-content-between">
                    <h5>Detail Purchase Order Nomor: {purchaseOrder.id} 
                        <span className={`badge ${purchaseOrder.status === 'stored' ? "badge-success" :  purchaseOrder.status === 'issued' ?  "badge-danger" : "badge-warning"}`}> {purchaseOrder.status}</span>
                    </h5>
                    <button
                        className="btn btn-primary"
                        onClick={() => window.location.assign('/admin/purchase-orders')}
                    >
                        Kembali ke Menu
                    </button>
                </div>
            </div>
            <h6>Info Pengiriman</h6>
            <div className="row">
                <div className="col-6">
                    <p>Tanggal pengiriman <b>{moment(purchaseOrder.deliveryDate).format("YYYY-MM-DD HH:mm:ss")}</b></p>
                    <p>Nama Supplier <b>{purchaseOrder.supplierName}</b></p>
                    <p>Nama Kontak Supplier <b>{purchaseOrder.supplierContactName}</b></p>
                    <p>Nomor Telpon Supplier <b>{purchaseOrder.supplierContactPhone}</b></p>
                </div>
                <div className="col-6">
                    <p>Nama Toko: <b>{purchaseOrder.catalogName}</b></p>
                    <p>Nama Organisasi: <b>{purchaseOrder.userOrganization}</b></p>
                    <p>Nama Pemilik: <b>{purchaseOrder.userName}</b></p>
                </div>
            </div>
            <h6>Keterangan</h6>
            <p>{purchaseOrder.note}</p>
            <hr/>
            {
                purchaseOrder.items.length === 0 ?
                    <h3 className="text-danger">Belum ada data barang</h3> :
                    <div>
                        <div className="row">
                            <div className=" col-sm-6">
                                <h6>Barang Masuk</h6>
                            </div>
                            <div className="input-group col-sm-2">
                                <button className="btn-block btn btn-primary" onClick={onSendPurchaseOrderEmail}>
                                    Kirim Email PO
                                </button>
                            </div>
                            <div className="input-group col-sm-2">
                                <button className="btn-block btn btn-light" onClick={() => window.open(`/admin/purchase-orders/${purchaseOrder.id}/download-pdf`) }>
                                    Download Barcode
                                </button>
                            </div>
                            <div className="input-group col-sm-2">
                                <button className="btn-block btn btn-light" onClick={onSendPurchaseOrderConfirmStock}>
                                    Update Stok Barang
                                </button>
                            </div>
                        </div>
                        <AdminPurchaseOrderItemsTable
                            data={purchaseOrder.items}
                        />
                    </div>
                    
            }
            <div className="my-4"/>
            <hr/>
            <div className="row">
                <div className=" col-sm-6">
                    <h6>Info Tambahan Barang</h6>
                </div>
                <div className="input-group col-sm-3">
                    <button
                        onClick={()=> handleModalShow('addProduct')}
                        className="btn-block btn btn-outline-dark"
                        type="button"
                    >
                        Tambah Produk
                    </button>
                </div>
                <div className="input-group col-sm-3">
                    <button
                        onClick={()=> setItems(purchaseOrder.items)}
                        className="btn-block btn btn-light"
                        type="button"
                    >
                        Copy Barang
                    </button>
                </div>
            </div>
            <div className="my-4"/>
            <div className="row">
                <div className="col-2">
                    <label className="col-form-label">Nama Barang</label>
                </div>
                <div className="col-10">
                    {
                        items.map((i, idx) => (
                            <div key={idx} className="px-3">
                                <div className="row bg-lighter border rounded py-2 mb-2">
                                    <div className="col-sm-2">
                                        <b>{i.name}</b>
                                    </div>
                                    <div className="col-sm-2">
                                        {i.sku}
                                    </div>
                                    <div className="col-sm-5">
                                        {i.details}
                                    </div>
                                    <div className="col-sm-2">
                                        <b>{i.quantity}</b>
                                    </div>
                                    <div className="col-sm-1">
                                        <a onClick={() => onRemoveItem(i.id)}
                                           className="action-item mr-2"
                                           data-toggle="tooltip"
                                           title="Remove">
                                            <i className="fas fa-times"></i>
                                        </a>
                                    </div>

                                </div>
                            </div>
                        ))
                    }
                    <div className="form-row">
                        <div className="input-group col-sm-8">
                            <select
                                id="inputState"
                                className="form-control"
                                onChange={value => onItemSelect(value)}
                            >
                                {
                                    purchaseOrder.catalogProducts.map((i,idx) => (
                                        <option
                                            key={idx}
                                            value={JSON.stringify(i)}
                                            className={`${idx === 0 ? "selected":""}`}
                                        >
                                            {`${i.name} - ${i.sku} - ${i.details}`}
                                        </option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className="input-group col-sm-2">
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Jumlah"
                                onChange={onItemChange('quantity')}
                                value={item.quantity}
                            />
                        </div>
                        <div className="input-group col-sm-2">
                            <button
                                onClick={()=> onAddItem()}
                                className="btn-block btn btn-outline-primary"
                                type="button"
                            >
                                Tambah
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="my-2"/>
            <div className="row">
                <div className="col-9"/>
                <div className="col-3">
                    <button
                        onClick={()=> onSubmitItems()}
                        className="btn-block btn btn-primary"
                        type="button"
                    >
                        Simpan Barang
                    </button>
                </div>
            </div>
        </div>
    )
};

export default PurchaseOrderDetail;
